// extracted by mini-css-extract-plugin
export var shake = "_redotech-redo-web-lib-alert-shake";